import { LaptopUpOnly, MobileOnly } from "@utils/MediaQueries"
import Link from "next/link"
import { up } from "styled-breakpoints"
import styled from "styled-components"

const ImageContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
`
const Image = styled.img`
  width: 700px;
  object-fit: cover;

  ${up("laptop")} {
    heigth: 100px;
  }
`
export default function Banner() {
  return (
    <Link href={"/configurator"}>
      <ImageContainer>
        <MobileOnly>
          <Image src="/tmi-banner.jpg" title="Banner" />
        </MobileOnly>
        <LaptopUpOnly>
          <Image src="/tmi-banner.jpg" title="Banner" />
        </LaptopUpOnly>
      </ImageContainer>
    </Link>
  )
}
